import React, { Fragment, FC } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import makeStyles from '@mui/styles/makeStyles';

import { Loader } from 'ui';
import { formatNumber } from 'shared/functions';

const useStyles = makeStyles(() => ({
  listItem: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    height: '60px',
  },
  listItemCount: {
    textAlign: 'right',
  },
}));

type CoverageWidgetParams = {
  data: Array<{ label: string; percent: number; total: number; id: string }>;
  loading: boolean;
  onItemClick: (id: string) => void;
  tooltip?: string;
};

const CoverageWidget: FC<CoverageWidgetParams> = ({ data, loading, onItemClick }) => {
  const classes = useStyles();

  return (
    <Paper>
      <List>
        {loading ? (
          <Loader center />
        ) : (
          data.map((element, index) => (
            <Fragment key={element.label}>
              <ListItem onClick={() => onItemClick(element.id)} button className={classes.listItem}>
                <ListItemText primary={`${element.label}`} />
                <ListItemText
                  primary={`${formatNumber(element.total)}`}
                  className={classes.listItemCount}
                />
              </ListItem>
              {data.length - 1 > index && <Divider />}
            </Fragment>
          ))
        )}
      </List>
    </Paper>
  );
};

export default CoverageWidget;
